<template>
  <div class="yk-course-videoTypeList-main">
    <div class="yk-course-new-content clearfix">
      <div class="clearfix search-head-con">
        <el-input placeholder="请输入串讲视频类型标题" v-model="videoTypeTitle" class="input-name-val" size="small" :clearable="true"></el-input>
        <el-button type="primary" size="small" icon="el-icon-search" @click="getVideoTypeList">搜索</el-button>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-circle-plus-outline"
          @click="showSave()"
        >添加</el-button>
      </div>
      <img
        :src="nodataImg"
        alt
        v-show="courseList.length==0"
        style="margin:100px auto 0px;display: block;"
        v-if="isLoad"
      />
      <div class="yk-course-list hor clearfix" v-if="courseList.length > 0">
        <el-table
          :data="courseList"
          style="width: 100%">
          <el-table-column
            prop="dateCreated"
            label="日期">
          </el-table-column>
          <el-table-column
            prop="videoTypeTitle"
            label="串讲视频类型名称">
          </el-table-column>
          <el-table-column
            prop="address"
            label="操作">
            <template scope="scope">
              <el-button type="primary" @click="getCourseInfo(scope.row)">编辑</el-button>
              <el-button type="danger" @click="deleteVideoType(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="onPageChangeHandler"
          :current-page="page"
          :page-sizes="[10, 20, 50, 100,200,500,1000]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalCount"
          v-show="totalCount>0"
          style="text-align: center;"
        ></el-pagination>
        <div class="itemempty"></div>
        <div class="itemempty"></div>
        <div class="itemempty"></div>
      </div>
      <el-dialog
        title="添加串讲视频"
        :visible.sync="rdialogVisible"
        width="40%"
        :append-to-body="true"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="handleClose"
      >
        <div class="material-form-detail clearfix">
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="180px"
            class="demo-ruleForm"
          >
            <el-form-item label="视频类型标题:" prop="videoTypeTitle">
              <el-input v-model="ruleForm.videoTypeTitle" placeholder="视频类型标题"></el-input>
            </el-form-item>
           
          </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button type="danger" @click="rdialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
export default Vue.extend({
  name: "course-list",
  data() {
    return {
      urlAliyunOSS: "/api/design/osssign/getsign",
      rdialogVisible: false,
      courseList: [],
      page: 1,
      pageSize: 10,
      totalCount: 0,
      isShowNull: false,
      nodataImg: require("assets/images/the-last-new-nodata-imag.png"),
      defaultCover: require("assets/images/news-bg.png"), // 默认封面
      videoTypeTitle: "",
      teaName: "",
      rules: {
        videoTypeTitle: [
          { required: true, message: "请输入串讲视频名称", trigger: "blur" }
        ]
      },
      ruleForm: {
        id: "",
        videoTypeTitle: ""
      },
      // 判断是否加载完成
      isLoad:false
    };
  },
  watch: {
    checkList(val) {
      console.log(val);
    }
  },
  created() {
    this.getVideoTypeList();
  },
  methods: {
    deleteVideoType(row){
      var that = this;
       that
        .$confirm("此操作将删除该串讲视频, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          that.$http
            .post("/api/XOrg/VideoType/deleteVideoType", {
              ids: row.iid
            })
            .then(rst => {
              if (rst.code > 0) {
                this.getVideoTypeList();
              } else {
                that.$message.warning(rst.msg);
              }
            });
        })
        .catch(() => {
          that.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    onDropdownClickHandler(cos) {
      var that = this;
      switch (cos.type) {
        case "delete":
          var arr = [];
          arr.push(cos.data.id);
          that
            .$confirm("此操作将删除该串讲视频, 是否继续?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning"
            })
            .then(() => {
              that.$http
                .post("/api/XOrg/VideoType/deleteVideoType", {
                  ids: arr
                })
                .then(rst => {
                  if (rst.code > 0) {
                    this.getVideoTypeList();
                  } else {
                    that.$message.warning(rst.msg);
                  }
                });
            })
            .catch(() => {
              that.$message({
                type: "info",
                message: "已取消删除"
              });
            });
          break;
        case "edit":
          that.getCourseInfo(cos.data);
          break;
        default:
          // this.$message.error('');新增
          break;
      }
    },
    //获取教材详情
    getCourseInfo(data) {
      var that = this;
      this.ruleForm.id = data.id;
      this.ruleForm.videoTypeTitle = data.videoTypeTitle;
      that.rdialogVisible = true;
    },
    showSave() {
      this.rdialogVisible = true;
    },
    handleClose() {
      this.ruleForm.id = "";
      this.ruleForm.videoTypeTitle = "";
      this.rdialogVisible = false;
    },
    getVideoTypeList() {
      var that = this;
      this.$http
        .post("/api/XOrg/VideoType/getVideoTypeList", {
          videoTypeTitle: this.videoTypeTitle,
          teaName: this.teaName,
          PageSize: that.pageSize,
          page: that.page
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.courseList = rst.list;
            that.page = rst.pagination.pageIndex;
            that.pageSize = rst.pagination.pageSize;
            that.totalCount = rst.pagination.totalCount;
            if (rst.list.length == 0) {
              that.isShowNull = true;
            }

          }
          that.isLoad = true;
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getVideoTypeList();
    },
    onPageChangeHandler(val) {
      this.page = val;
      this.getVideoTypeList();
    },
    submitForm() {
      var that = this;
      that.isButton = false;
      that.$refs["ruleForm"].validate(valid => {
        if (valid) {
          that.addOrEditVideoType();
        } else {
          that.isButton = true;
          return false;
        }
      });
    },
    addOrEditVideoType() {
      var that = this;
      this.$http
        .post("/api/XOrg/VideoType/addOrEditVideoType", {
          id: this.ruleForm.id,
          videoTypeTitle: this.ruleForm.videoTypeTitle
        })
        .then(function(rst) {
          if (rst.code > 0) {
            that.getVideoTypeList();
            that.handleClose();
          }
        });
    }
  }
});
</script>

<style lang="scss">
.yk-course-videoTypeList-main {
  padding-bottom: 40px;
  position: relative;
  .search-head-con {
    // position: fixed;
    top: 60px;
    right: 30px;
    height: 60px;
    // width: 500px;
    z-index: 1000;
    background: #fff;
    text-align: right;
    text-align: right;
    line-height: 60px;
    .input-name-val {
      margin-right: 15px;
      width: 240px;
    }
  }
  .material-form-detail {
    margin-left: 79px;
    width: 60%;
    .mater-form-file {
      .el-upload-list {
        float: left;
        background: #3f5880;
        width: 100%;
        border-radius: 4px;
        margin-bottom: 20px;
        .el-upload-list__item {
          margin: 0;
          padding: 6px 0;
          background: #415474;
          padding-left: 18px;
          .el-upload-list__item-name {
            color: #ffffff;
            padding-left: 0;
            .el-icon-document::before {
              color: #ffffff;
            }
          }
          .el-upload-list__item-status-label {
            top: 8px;
            right: 30px;
            border-radius: 4px;
            .el-icon-upload-success {
              color: #409eff;
            }
          }
          .el-icon-close {
            width: 13px;
            height: 13px;
            border-radius: 50%;
            background: #ee4166;
            top: 13px;
            right: 30px;
            font-size: 10px;
            line-height: 14px;
            text-align: center;
          }
          .el-icon-close-tip {
            display: none;
          }
        }
      }
      .el-upload__tip {
        display: inline-block;
        color: #ee4166;
        margin-top: 0;
      }
    }
  }

  .is-bordered {
    padding: 10px 10px 5px 10px;
  }
  .yk-course-new-content {
    .school-course-name {
      cursor: pointer;
      padding: 20px;
    }
    .school-course-active {
      color: #3fa2ff;
    }
    .yk-course-new-sortContent-new {
      text-align: right;
      position: fixed;
      right: 60px;
      top: 6px;
      z-index: 2000;
      .a-tea-work {
        font-size: 18px;
        width: 105px;
        text-decoration: none;
        color: #eeca1e;
        height: 32px;
        display: inline-block;
        text-align: center;
        line-height: 40px;
        border-radius: 3px;
        margin-right: 15px;
        i {
          font-size: 26px;
          float: left;
        }
      }
      .genduo {
        color: #409eff;
        font-size: 25px;
        position: relative;
        top: 5px;
        left: 3px;
      }
    }
    .yk-course-list {
      width: 100%;
      .yk-course-new-add {
        box-sizing: border-box;
        margin: 0px 16px 22px;
        margin-top: 40px;
        width: 372px;
        height: 320px;
        border: 2px dashed #409eff;
        border-radius: 10px;
        box-shadow: 4px 0px 10px rgba(0, 0, 0, 0.15);
        text-align: center;
        background-color: #fff;
        cursor: pointer;
        .wl-icon-add-wrapper {
          margin-top: 85px;
          .wl-icon-tianjia {
            text-align: center;
            font-size: 100px;
            color: #409eff;
            border: 3px solid #409eff;
            border-radius: 50%;
          }
        }
        .yk-add-course-title {
          margin-top: 29px;
          font-size: 20px;
          color: #409eff;
          line-height: 1;
        }
      }
      .itemempty {
        margin: 0px 16px 22px;
        margin-top: 40px;
        width: 372px;
        height: 0;
      }
      .yk-course {
        position: relative;
        margin-top: 40px;
        width: 300px;
        height: 280px;
        border-radius: 10px;
        box-shadow: 4px 0px 10px rgba(0, 0, 0, 0.15);
        text-align: center;
        cursor: pointer;
        background-color: #fff;
        border: none;
        color: white;
        display: inline-block;
        margin: 0 16px 22px;
        text-decoration: none;
        .yk-course-teacher-name {
          margin-top: 18px;
          color: #999999;
          font-size: 16px;
        }
        .yk-course-publish-new {
          position: absolute;
          right: 15px;
          bottom: 15px;
          .el-dropdown {
            button {
              background-color: rgba(255, 255, 255, 0.747);
              .wl-icon-gengduoxiao {
                font-size: 25px;
                color: #409eff;
              }
            }
          }
        }
      }
      .img-jp-icon {
        position: absolute;
        bottom: -25px;
        left: -16px;
      }
    }
  }
}

</style>
